import { DefaultButtonsConfig } from './../../base-models/default-buttons-config';
import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, TemplateRef } from '@angular/core';

@Component({
  selector: 'yt-fw-default-list-buttons',
  templateUrl: './default-list-buttons.component.html'
})
export class DefaultListButtonsComponent implements OnInit {

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  @Input() ButtonsDisabled: boolean = false;
  @Input() PrintButtonEnabled: boolean = false;
  @Input() PrintSelectedButtonEnabled: boolean = false;
  @Input() ButtonsConfig: DefaultButtonsConfig;

  @Output() AddItemClicked = new EventEmitter();
  @Output() DeleteItemsClicked = new EventEmitter();
  @Output() PrintClicked = new EventEmitter();
  @Output() PrintSelectedClicked = new EventEmitter();
  @Input() extraButtonsTemplate: TemplateRef<any>;

  ngOnInit() {
  }

  OnAddItem(){

    this.AddItemClicked.emit();
  }

  OnDeleteItems(){
    this.DeleteItemsClicked.emit();
  }

  OnPrint(){
    this.PrintClicked.emit();
  }

  OnPrintSelected(){
    this.PrintSelectedClicked.emit();
  }

}
